import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Geometry, Point } from 'geojson';
import { AppMessage } from '../../../../shared/app-message/app-message';
import { AppMessageService } from '../../../../shared/app-message/app-message.service';
import { MapElement } from '../../../../shared/map/map-element.model';
import { MapService } from '../../../../shared/map/map.service';
import { SidebarService } from '../../../../shared/sidebar/sidebar.service';
import { StateService } from '../../../../shared/state/state.service';
import { RunningTrain } from '../../common/train';
import { _ } from '../../../../shared/utils';
import { TabId } from '../../train-info/train-info/train-info.component';

@Component({
  selector: 'qm-train-alarm-actions',
  templateUrl: './train-alarm-actions.component.html',
  styleUrls: ['./train-alarm-actions.component.scss']
})
export class TrainAlarmActionsComponent implements OnInit {

  @Input() public trainDate: string;
  @Input() public tripNumber: string;
  @Input() public trainCategory: string;
  @Input() public reversed: boolean = false;
  @Input() public openPanelOnClick: boolean = true;
  @Input() public openTab: TabId = 'schedule';
  @Input() public darkBtn: boolean = false;
  @Output() public trainNumberClicked = new EventEmitter<{ trainDate: string, tripNumber: string, event: Event }>();

  public isTrainOnMap: boolean = false;
  public feature: MapElement<Point, RunningTrain>;

  constructor(
    private state: StateService,
    private mapService: MapService,
    private sidebarService: SidebarService,
    private appMessageService: AppMessageService
  ) { }

  public ngOnInit(): void {
    // const trainId = `${this.trainDate}_${this.tripNumber}`;
    // this.feature = this.mapService.getFeatureById(trainId) as MapElement<Point, RunningTrain>;
    // this.isTrainOnMap = !!this.feature;
  }

  public openDetails(event: Event, trainDate: string, tripNumber: string) {
    this.trainNumberClicked.next({ trainDate, tripNumber, event });
    if (this.openPanelOnClick) {
      // Equipment doesn't have a date and they use the tripNumber as an id
      const featureId = trainDate ? `${trainDate}_${tripNumber}` : tripNumber;
      const panelName: string = 'ElementInfo';
      const panelId = panelName + featureId;
      this.state.updateState(panelId, featureId);
      this.mapService.changeCurrentFeature(this.feature);
      this.sidebarService.requestSidebarPanel(panelId, { openTab: this.openTab });
    }
  }

  public focusMarker() {
    if (!!this.feature) {
      this.feature.layer.setVisibility(true);
      this.mapService.changeCurrentFeature(this.feature);
      this.mapService.flyTo({ lat: this.feature.geometry.coordinates[1], lng: this.feature.geometry.coordinates[0] });
    } else {
      const msg = new AppMessage(true, _('Alarm doesn´t have marker!'), 'error', 'alarms', '');
      this.appMessageService.broadcastAlarm(msg);
    }
 }

}
